import { RootState } from '../store';

export const selectPretestQuestions = (state: RootState) =>
  state.pretestReducer.pretestQuestions;

export const selectPretestIsReady = (state: RootState) =>
  state.pretestReducer.loading || state.examinationReducer.loading;

export const selectPretestError = (state: RootState) => ({
  error: state.pretestReducer.error,
  message: state.pretestReducer.errorMessage,
  details: state.pretestReducer.errorDetails,
});
